import {createRouter, createWebHistory} from "vue-router"
import HomePage from "../pages/HomePage.vue";
import AboutPage from "../pages/AboutPage.vue";
import FourOFour from '../pages/FourOFour.vue';
import ProjectsPage from "@/pages/ProjectsPage.vue";
import ContactPage from "@/pages/ContactPage.vue";
import ImpressPage from "@/pages/ImpressPage.vue";
import PrivacyPage from "@/pages/PrivacyPage.vue";

const routes = [
    {
        path: "/", 
        component: HomePage,
    },
    {
        path: "/:catchAll(.*)",
        component: FourOFour,
        props: true
    },
    {
        path: "/about", 
        component: AboutPage
    },
    {
        path:"/projects",
        component: ProjectsPage
    },
    {
        path:"/contact",
        component: ContactPage
    },
    {
        path:"/impress",
        component: ImpressPage
    },
    {
        path:"/privacy",
        component: PrivacyPage
    }
]

export const router = createRouter({
    history: createWebHistory(),
    routes
});
